import { createContext } from 'react'
import { Product } from '../products/Products'

export const AppContext = createContext<AppContextData>({
    product: undefined,
    fixPath: (path: string) => '',
    onSignedIn: () => {},
})

export interface AppContextData {
    product?: Product
    fixPath(path: string): string
    onSignedIn(): any
}
